<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => ['response', 'document'].includes(value),
  },
  bulkIds: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['deleteSuccess']);

const { t } = useI18n();
const store = useStore();
const bulkDeleteDialogRef = ref(null);
const i18nKey = computed(() => {
  const i18nTypeMap = {
    response: 'RESPONSES',
    document: 'DOCUMENTS',
  };
  return i18nTypeMap[props.type];
});

const handleBulkDelete = async () => {
  try {
    await store.dispatch('assistantBulkActions/handleBulkDelete', {
      ids: Array.from(props.bulkIds),
      type: props.type,
    });

    emit('deleteSuccess');
    useAlert(t(`ASSISTANT.${i18nKey.value}.BULK_DELETE.SUCCESS_MESSAGE`));
  } catch (error) {
    useAlert(t(`ASSISTANT.${i18nKey.value}.BULK_DELETE.ERROR_MESSAGE`));
  }
};

const handleDialogConfirm = async () => {
  await handleBulkDelete();
  bulkDeleteDialogRef.value?.close();
};

defineExpose({ dialogRef: bulkDeleteDialogRef });
</script>

<template>
  <Dialog
    ref="bulkDeleteDialogRef"
    type="alert"
    :title="t(`ASSISTANT.${i18nKey}.BULK_DELETE.TITLE`)"
    :description="t(`ASSISTANT.${i18nKey}.BULK_DELETE.DESCRIPTION`)"
    :confirm-button-label="t(`ASSISTANT.${i18nKey}.BULK_DELETE.CONFIRM`)"
    @confirm="handleDialogConfirm"
  />
</template>
